interface IToggleSwitch {
    onChange?: (value: boolean) => void;
    checked?: boolean
    isLabel?: boolean
}

const ToggleSwitch = ({ onChange, checked = true, isLabel = true }: IToggleSwitch) => {
    return (
        <label className="flex justify-center items-center gap-1 h-full text-black text-sm cursor-pointer">
            <input
                type="checkbox"
                checked={checked}
                className="sr-only peer"
                onChange={(e) => {
                    onChange?.(e.target.checked)
                }}
            />
            <div className="peer after:top-[2px] after:absolute relative bg-gray-200 after:bg-white peer-checked:bg-[#4AD35E] after:border after:border-gray-300 peer-checked:after:border-white rounded-full after:rounded-full w-11 after:w-5 h-6 after:h-5 after:content-[''] after:transition-all rtl:peer-checked:after:-translate-x-full peer-checked:after:translate-x-full after:start-[2px]"></div>
            {
                isLabel &&
                <span>{checked ? '표시' : '숨김'}</span>
            }
        </label>
    )
}

export default ToggleSwitch